import { render, staticRenderFns } from "./ModalGallery.vue?vue&type=template&id=2e054904"
import script from "./ModalGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalGallery.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalGallery.vue?vue&type=style&index=0&id=2e054904&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports